import React from 'react';
import { styled } from 'linaria/react';
import { css, cx } from 'linaria';
import { Link } from 'react-router-dom';
import Spinner from './Spinner';
import t from '@jetshop/intl';
import { theme } from '../Theme';
import { isRelativeUrl } from '@jetshop/core/helpers/isRelativeUrl';
import ButtonUI from '@jetshop/ui/Button/Button';

export const baseStyles = css`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${theme.colors.accent};
  color: ${theme.colors.white};
  background-color: ${theme.colors.accent};
  font-size: calc(12rem / 16);
  font-weight: 600;
  border-radius: 999px;
  padding: 0 ${theme.space.md};
  height: 42px;
  letter-spacing: 0.1em;
  transition: 0.2s;
  span {
    margin-right: 12px;
  }
  svg {
    fill: white;
    height: 1em;
    width: 1em;
    margin-right: 1em;
  }
  ${theme.above.md} {
    max-width: 100%;
  }

  :disabled {
    border: 1px solid #dedede;
    opacity: 0.5;
  }
  &:hover {
    color: ${theme.colors.white} !important;
    background-color: ${theme.colors.accent};
  }
`;

const BaseButton = styled('button')`
  background-color: transparent;
`;

const TrendABase = styled('a')`
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 54px;
`;

const TrendLinkBase = styled(Link)`
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 54px;
`;

const StyledButton = styled(ButtonUI)``;

const ButtonLink = styled(Link)`
  text-decoration: none;
`;

export function TrendLink({ to, className, ...props }) {
  return typeof to === 'string' && !isRelativeUrl(to) ? (
    <TrendABase href={to} className={cx(className, baseStyles)} {...props} />
  ) : (
    <TrendLinkBase to={to} className={cx(className, baseStyles)} {...props} />
  );
}

const StyledSpinner = styled(Spinner)`
  height: 25px;
  circle.path {
    stroke: white;
  }
`;

export const Button = ({
  className = '',
  secondary = false,
  outline = false,
  link = '',
  ...props
}) => {
  return link !== '' && isRelativeUrl(link) ? (
    <ButtonLink
      to={link}
      className={cx(
        baseStyles,
        secondary && secondaryStyle,
        outline && outlineStyle,
        className
      )}
      {...props}
    />
  ) : (
    <StyledButton
      anchor={link !== ''}
      href={link}
      className={cx(
        baseStyles,
        secondary && secondaryStyle,
        outline && outlineStyle,
        className
      )}
      {...props}
    />
  );
};

const ButtonWithLoading = ({
  loading,
  loadingText = t('Hold on a moment...'),
  secondary,
  className,
  ...props
}) =>
  loading ? (
    <BaseButton
      {...props}
      className={cx(secondary && secondaryStyle, baseStyles, className)}
    >
      <span>{loadingText}</span>
      <StyledSpinner />
    </BaseButton>
  ) : (
    <BaseButton
      {...props}
      className={cx(secondary && secondaryStyle, baseStyles, className)}
    />
  );

export default ButtonWithLoading;

const secondaryStyle = css`
  border: 1px solid ${theme.colors.white};
  color: ${theme.colors.accent};
  background-color: ${theme.colors.white};
  circle.path {
    stroke: black;
  }

  &:hover {
    color: ${theme.colors.accent} !important;
    background-color: ${theme.colors.white};
  }
`;

const outlineStyle = css`
  background-color: transparent;
  &.${secondaryStyle} {
    color: ${theme.colors.white};
  }
  &:not(.${secondaryStyle}) {
    color: ${theme.colors.accent};
  }
`;
